import { useState, useEffect, useRef } from 'react';
import { SemanticCOLORS } from 'semantic-ui-react';

export function chunks(items: any[], chunkSize: number) {
    const result = [];
    for (let i = 0; i < items.length; i += chunkSize) {
        result.push(items.slice(i, i + chunkSize));
    }

    return result;
}


export const upperFirst = (s: string) => (
    s.charAt(0).toUpperCase() + s.slice(1)
);


export const lowerFirst = (s: string) => (
    s.charAt(0).toLowerCase() + s.slice(1)
);


const envColorMap = new Map<string, SemanticCOLORS>([
    ["prod", "blue"],
    ["ppe", "orange"],
    ["dev", "teal"],
    ["qa", "green"]
]);


export function getEnvName() {
    const envDelimiter: string = "-";
    const defaultEnv = "prod";
    const { REACT_APP_IRPM_UI_NAME: uiName } = process.env;

    if (uiName == undefined) {
        return defaultEnv;
    }

    let envName = uiName.slice(uiName.indexOf(envDelimiter) + 1);
    if (envName === "DataExtractorUILocal") {
        envName = "dev";
    } else if (envName === "DataExtractorUI") {
        envName = "prod";
    }

    if (!envColorMap.has(envName)) {
        return defaultEnv;
    }

    return envName;
}


export function getColorByEnv() {
    const envName = getEnvName()!;
    return envColorMap.get(envName);
};


export const envColor: SemanticCOLORS = getColorByEnv()!;


export function confirmationWindowByEnvs(message: string, envs: string[]) {
    const envName = getEnvName()!;
    const found = envs.find(
        (env) => {
            return env == envName;
        }
    );

    if (found) {
        return window.confirm(message);
    }

    return undefined;
};


export const toBase64 = (file: File) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
});


export type Constructor<T = {}> = new (...args: any[]) => T;


type StateChangedCallback<T> = ((state: T) => void) | null;
type SetStateCallback<T> = (state : T, callback?: StateChangedCallback<T>) => void;

export function useStateWithCallback<T>(
    initialState: T,
    callback?: StateChangedCallback<T>
) : [T, SetStateCallback<T>] {
    const callbackRef = useRef<StateChangedCallback<T>>(null);
    const [value, setValue] = useState(initialState);

    useEffect(() => {
      if (callbackRef.current) {
        callbackRef.current(value);
        callbackRef.current = null;
      }
      else if (callback) {
          callback(value);
      }
    }, [value]);

    const setValueWithCallback = (newValue: T, callback?: StateChangedCallback<T>) => {
        if (callback) {
            callbackRef.current = callback;
        }
        return setValue(newValue);
    };

    return [value, setValueWithCallback];
};
